/* vim: set ts=2 sw=2 sts=2 et: */

/**
 * Copyright (c) 2001-present X-Cart Holdings LLC. All rights reserved.
 * See https://www.x-cart.com/license-agreement.html for license details.
 */

export default function fetchScenario(store, type) {
  return (to, from, next) => {
    store.dispatch('scenarios/fetch', type);
    next();
  };
}



// WEBPACK FOOTER //
// ./src/router/guards.js